const LightBlueTag = ({ children, onClick }) => {
  return (
    <span
      className="text-appblue bg-gray rounded-md text-sm"
      onClick={onClick}
      style={{ padding: "7.5px 12px" }}
    >
      {children}
    </span>
  );
};

export default LightBlueTag;
